export default __webpack_public_path__ + "static/media/IMG_2703 (1).4fe9c8f3.jpg";